import { defineMessages } from 'react-intl';

const messages = defineMessages({
  show_map_full_width: {
    id: 'show_map_full_width',
    defaultMessage: 'Mostra la mappa a tutta larghezza',
  },
  map_size: {
    id: 'Dimensione della mappa',
    defaultMessage: 'Dimensione della mappa',
  },
  map_size_small: {
    id: 'map_size_small',
    defaultMessage: 'Piccola',
  },
  map_size_medium: {
    id: 'map_size_medium',
    defaultMessage: 'Media',
  },
  map_size_large: {
    id: 'map_size_large',
    defaultMessage: 'Grande',
  },
});

const getMapVariationSchema = (schema, formData, intl, position = 0) => {
  let itemsFieldset = schema.fieldsets.find((fs) => fs.id === 'items');
  if (!itemsFieldset) {
    itemsFieldset = { id: 'items', title: 'Items', fields: [] };
    schema.fieldsets.splice(1, 0, itemsFieldset);
  }

  itemsFieldset.fields.push('show_map_full_width', 'map_size');

  schema.properties.show_map_full_width = {
    title: intl.formatMessage(messages.show_map_full_width),
    type: 'boolean',
  };

  schema.properties.map_size = {
    title: intl.formatMessage(messages.map_size),
    type: 'string',
    choices: [
      ['small', intl.formatMessage(messages.map_size_small)],
      ['medium', intl.formatMessage(messages.map_size_medium)],
      ['large', intl.formatMessage(messages.map_size_large)],
    ],
    default: 'medium',
  };

  return position;
};

export default getMapVariationSchema;
